/* eslint-disable react/no-unused-prop-types */
/* eslint-disable sonarjs/prefer-single-boolean-return */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable sonarjs/no-duplicated-branches */
/* eslint-disable sonarjs/cognitive-complexity */
import { useMsal } from "@azure/msal-react";
import { addHours, addMinutes, format, subHours, subMinutes } from "date-fns";
import moment from "moment";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import { useLocation } from "react-router-dom";

import AutocompleteFloatLabelClean from "../../components/AutocompleteFloatLabelClean";
import { StyledDefaultButtonLink } from "../../components/ButtonsComponents";
import Dialog from "../../components/Dialog";
import DialogMessage from "../../components/DialogMessage";
import {
    AlertStatus,
    CheckIcon,
    DeleteIcon,
    DoneIcon,
    EditIcon,
} from "../../components/Icons";
import DialogMessageProps from "../../model/DialogMessageProps";
import { Routes } from "../../model/Enums/RoutesEnum";
import {
    StatusCheckinEnum,
    StatusCheckinEnumLabel,
    StatusCheckinEnumType,
} from "../../model/Enums/StatusCheckinEnum";
import {
    TipoCartaoEnum,
    getLabelTipoCartaoEnum,
    isCartaoEspecial,
    isOvertimeCard,
} from "../../model/Enums/TipoCartaoEnum";
import { TypeDialogMessageEnum } from "../../model/Enums/TypeDialogMessageEnum";
import IModalProps from "../../model/ModalProps";
import CartoesService from "../../service/Docente/CartoesService";
import ScheduleService from "../../service/Docente/ScheduleService";
import ButtonStyles from "../../styles/components/ButtonStyles";
import {
    StyledAlertStatus,
    StyledAlertText,
    StyledCardGrey,
    StyledCourse,
    StyledDetails,
    StyledHour,
    StyledInfoLabel,
    StyledInfoText,
    StyledProfessionalPractice,
} from "../../styles/pages/Schedule/ModalViewDetailsStyles";
import { MASK_DATE, MASK_TIME } from "../../utils/constants";
import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";
import ModalDeleteAbono from "./ModalDeleteAbono";
import ModalJustifyCheckin from "./ModalJustifyCheckin/ModalJustifyCheckin";
import DateUtils from "../../utils/DateUtils";
import PaginationModel from "../../model/dto/PaginationModel";
import SporadicActivity from "../../model/dto/SporadicActivity";
import SelectOption from "../../model/SelectOption";
import {
    WorkflowTypeEnum,
    WorkflowTypeEnumLabel,
} from "../../model/Enums/WorkflowTypeEnum";

const { BtnOutlinePrimary, BtnLink } = ButtonStyles;

type Holiday = {
    campus: string;
    color: string;
    description: string;
    end: string;
    id: number;
    start: string;
    title: string;
    type: string;
};
interface IModalViewDetailsProps extends IModalProps {
    detail: any;
    finalDate: string;
    validView?: boolean;
    params?: any;
    validTurn: boolean;
    setValidTurn: Dispatch<SetStateAction<boolean>>;
    handleCheckin: (cardId: any) => Promise<boolean>;
    parametrosAgenda?: any;
    blockActivy?: boolean;
    refreshScheduleData?: () => void;
    refreshScheduleCard?: (cartaoAgendaId: number[]) => void;
    edicaoAgenda: boolean;
    docente?: any;
    holidays?: Holiday[];
    linkedCard?: LinkedCardType;
    isSaveScheduleButtonDisabled: boolean;
}

type LinkedCardType = {
    linkedCardType?: TipoCartaoEnum | 0;
    linkedCardAllocationDate?: string;
};

const schoolHoursSubstitutionCardPermission = {
    nomeAtividade: true,
    nomeAtividadeSelect: false,
    nomeCurso: true,
    local: false,
    periodo: true,
    turma: true,
    divisao: true,
    tipoHora: true,
    horaInicio: true,
    horaFim: true,
    statusCheckin: true,
};

const nonSchoolHoursSubstitutionCardPermission = {
    nomeAtividade: true,
    nomeAtividadeSelect: false,
    nomeCurso: true,
    local: false,
    periodo: false,
    turma: false,
    divisao: false,
    tipoHora: true,
    horaInicio: true,
    horaFim: true,
    statusCheckin: true,
};

const formatAddHours = (
    date: any,
    additionHours: any,
    additionMinutes: any
) => {
    const newDateHours = subHours(date, additionHours);
    const newDateMinutes = subMinutes(newDateHours, additionMinutes);

    return GenericUtils.isValidDate(newDateMinutes)
        ? format(newDateMinutes, MASK_TIME)
        : "";
};

const formatSubHours = (
    date: any,
    additionHours: any,
    additionMinutes: any
) => {
    const newDateHours = addHours(date, additionHours);
    const newDateMinutes = addMinutes(newDateHours, additionMinutes);

    return GenericUtils.isValidDate(newDateMinutes)
        ? format(newDateMinutes, MASK_TIME)
        : "";
};

const validToleranceHoursSchoolTime = (
    currentTime: any,
    toleranceInitial: any,
    toleranceFinal: any
) => {
    if (currentTime < toleranceInitial) {
        return false;
    }

    return !(currentTime > toleranceFinal);
};

const checkTurn = (now: Date, params: any) => {
    const formatDate = format(now, MASK_DATE);
    const initialMorning = new Date(`${formatDate} ${params.turnoManhaInicio}`);
    const finalMorning = new Date(`${formatDate} ${params.turnoManhaTermino}`);
    const initialAfternoon = new Date(
        `${formatDate} ${params.turnoTardeInicio}`
    );
    const finalAfternoon = new Date(
        `${formatDate} ${params.turnoTardeTermino}`
    );
    const initialNight = new Date(`${formatDate} ${params.turnoNoiteInicio}`);
    const finalNight = new Date(`${formatDate} ${params.turnoNoiteTermino}`);

    if (
        initialNight.getTime() <= now.getTime() &&
        finalNight.getTime() >= now.getTime()
    ) {
        return "noite";
    }

    if (
        initialAfternoon.getTime() <= now.getTime() &&
        finalAfternoon.getTime() >= now.getTime()
    ) {
        return "tarde";
    }

    if (
        initialMorning.getTime() <= now.getTime() &&
        finalMorning.getTime() >= now.getTime()
    ) {
        return "manha";
    }

    return "bloqueado";
};

function ModalViewDetails(props: IModalViewDetailsProps) {
    const { instance } = useMsal();

    console.log("props.detail", props.detail);

    const [permission, setPermission] = useState<any>(null);
    const [typeCard] = useState(
        isCartaoEspecial(props.detail.cartaoTipo.cartaoTipoId) &&
            props.detail.cartaoTipo.cartaoTipoId !==
                TipoCartaoEnum.HoraExtraImportacao &&
            props.detail.cartaoTipo.cartaoTipoId !==
                TipoCartaoEnum.HoraExtraTela
            ? props.detail.cartaoTipoOrigem.cartaoTipoId
            : props.detail.cartaoTipo.cartaoTipoId
    );
    const [typeOriginCard] = useState(
        props.detail?.cartaoTipoOrigem?.cartaoTipoId
    );
    const [sporadicActivityOptions, setSporadicActivityOptions] = useState<
        SelectOption[]
    >([]);
    const [sporadicActivitySelected, setSporadicActivitySelected] = useState<
        any[]
    >([]);
    const [isOpen, setIsOpen] = useState(true);
    const [editMode, setEditMode] = useState(false);
    const [editedCard, setEditedCard] = useState<any>(null);
    const [modalJustify, setModalJustify] = useState(false);
    const [modalDelAbono, setModalDelAbono] = useState(false);
    const [dialogMessageProps, setDialogMessageProps] =
        useState<DialogMessageProps>({} as DialogMessageProps);
    const [justificationDate, setJustificationDate] = useState<Date | null>(
        null
    );
    const isFormValid = Boolean(sporadicActivitySelected.length);
    const user1 = JSON.parse(localStorage.getItem("user") ?? "{}");

    const location = useLocation();
    const pathLocation = location.pathname.split("/")[1];

    const getSporadicActivities = async () => {
        const { cartaoAgendaId } = props.detail;
        const { cartaoTipoId } = props.detail.cartaoTipo;

        if (
            !cartaoAgendaId ||
            ![TipoCartaoEnum.HoraNaoLetiva, TipoCartaoEnum.Esporadica].includes(
                cartaoTipoId
            )
        )
            return;

        const selected = [
            GenericUtils.impl<SelectOption>({
                value: "0",
                label: props.detail.tituloCartao,
            }),
        ];

        const response = await CartoesService.getSporadicActivitiesByCardId(
            instance,
            cartaoAgendaId
        );

        if (GenericUtils.isSuccessStatus(response)) {
            const page = response.data as PaginationModel<SporadicActivity>;
            setSporadicActivityOptions(
                page.itens.map((item: SporadicActivity) => {
                    return GenericUtils.impl<SelectOption>({
                        value: item.atividadeId.toString(),
                        label: item.descricao,
                    });
                })
            );
            setSporadicActivitySelected(selected);
        } else {
            setSporadicActivityOptions([]);
            setDialogMessageProps(GenericUtils.getPropsDialogError(response));
        }
    };

    const checkinStatus = props.detail?.statusCheckin as string | undefined;

    const legalAllowance = StatusCheckinEnumLabel.get(
        StatusCheckinEnum.AbonoLegal
    );

    const activityManagement = WorkflowTypeEnumLabel.get(
        WorkflowTypeEnum.GestaoAtividades
    );

    const adminAllowance = StatusCheckinEnumLabel.get(
        StatusCheckinEnum.AbonoAdministrativo
    );

    const handleClose = () => {
        if (props.onClose) props.onClose({ data: editedCard });
    };

    const handleSave = async () => {
        if (!isFormValid) return;
        if (StringUtils.isBeforeCurrentDateTime(props.detail?.start)) {
            setDialogMessageProps({
                show: true,
                type: TypeDialogMessageEnum.Error,
                title: "Não é possível editar cartões no passado",
            });
            return;
        }

        const agendaDTO = props.detail;
        agendaDTO.tituloCartao = sporadicActivitySelected.at(0)?.label;
        agendaDTO.title = sporadicActivitySelected.at(0)?.label;
        agendaDTO.cartaoTipo.cartaoTipoId = 5;
        agendaDTO.cartaoTipo.cartaoTipoNome = getLabelTipoCartaoEnum(
            TipoCartaoEnum.Esporadica
        );

        if (!agendaDTO.cartaoAgendaId) {
            setEditedCard(agendaDTO);
            setEditMode(false);
            setDialogMessageProps({
                show: true,
                type: TypeDialogMessageEnum.Success,
                title: "Atividade salva com sucesso",
            });
            return;
        }

        const response = await ScheduleService.editCard(agendaDTO, instance);

        if (GenericUtils.isSuccessStatus(response)) {
            setEditedCard(agendaDTO);
            setEditMode(false);
            setDialogMessageProps({
                show: true,
                type: TypeDialogMessageEnum.Success,
                title: "Atividade salva com sucesso",
            });
        } else {
            setDialogMessageProps(GenericUtils.getPropsDialogError(response));
        }
    };

    const modalJustifyCheckin = (
        <ModalJustifyCheckin
            open={modalJustify}
            parametrosAgenda={props.parametrosAgenda}
            detail={props.detail}
            refreshScheduleData={props.refreshScheduleData}
            refreshScheduleCard={props.refreshScheduleCard}
            onClose={() => {
                setModalJustify(false);
                setIsOpen(true);
                props.onClose?.();
            }}
            docente={props.docente}
        />
    );

    const modalDeleteAbono = (
        <ModalDeleteAbono
            open={modalDelAbono}
            detail={props.detail}
            refreshScheduleCard={props.refreshScheduleCard}
            onClose={() => {
                setModalDelAbono(false);
                setIsOpen(true);
                props.onClose?.();
            }}
        />
    );

    const dialogMessage = (
        <DialogMessage
            type={dialogMessageProps.type}
            show={dialogMessageProps.show}
            title={dialogMessageProps.title}
            text={dialogMessageProps.text}
            onClose={() => setDialogMessageProps({} as DialogMessageProps)}
        />
    );

    const toleranceCard = [
        TipoCartaoEnum.HoraNaoLetiva,
        TipoCartaoEnum.HoraNaoLetivaFlutuante,
    ].includes(typeCard);

    const initalHourSchoolTime = !toleranceCard
        ? props?.params?.horaLetivaToleranciaInicio?.substring(0, 2)
        : props?.params?.horaNaoLetivaToleranciaInicio?.substring(0, 2);
    const initalMinutesSchoolTime = !toleranceCard
        ? props?.params?.horaLetivaToleranciaInicio?.substring(3, 5)
        : props?.params?.horaNaoLetivaToleranciaInicio?.substring(3, 5);

    const finalHourSchoolTime = !toleranceCard
        ? props?.params?.horaLetivaToleranciaTermino?.substring(0, 2)
        : props?.params?.horaNaoLetivaToleranciaFim?.substring(0, 2);
    const finalMinutesSchoolTime = !toleranceCard
        ? props?.params?.horaLetivaToleranciaTermino?.substring(3, 5)
        : props?.params?.horaNaoLetivaToleranciaFim?.substring(3, 5);

    const dateNowSchoolTime = new Date(
        `${props.detail.data} ${props.detail.horaInicio}`
    );

    const dateNowNonSchoolTime = new Date(
        `${props.detail.data} ${props.detail.horaFim}`
    );

    const formatDateAdd = formatAddHours(
        dateNowSchoolTime,
        initalHourSchoolTime,
        initalMinutesSchoolTime
    );

    const formatDateSub = formatSubHours(
        toleranceCard ? dateNowNonSchoolTime : dateNowSchoolTime,
        finalHourSchoolTime,
        finalMinutesSchoolTime
    );

    const currentDate = new Date();
    const inititalDate = new Date(`${props.detail.data} ${formatDateAdd}`);
    const finalDate = new Date(`${props.detail.data} ${formatDateSub}`);

    const isValidCheckin = validToleranceHoursSchoolTime(
        currentDate.getTime(),
        inititalDate.getTime(),
        finalDate.getTime()
    );

    const isValidCheckinAndTurn = props.validTurn ? false : !isValidCheckin;
    const turn = checkTurn(currentDate, props.params);

    const validNow = Date.now() > finalDate.getTime();

    const retroactiveBlocking =
        [TipoCartaoEnum.HoraLetiva].includes(typeCard) && validNow;

    const shouldShowActivityName = () => {
        return (
            typeCard === TipoCartaoEnum.HoraLetiva ||
            typeCard === TipoCartaoEnum.AtividadesAvulsas ||
            (typeCard === TipoCartaoEnum.Antecipacao &&
                typeOriginCard === TipoCartaoEnum.HoraLetiva) ||
            (typeCard === TipoCartaoEnum.Antecipacao &&
                typeOriginCard === TipoCartaoEnum.HoraNaoLetiva) ||
            (typeCard === TipoCartaoEnum.Antecipacao &&
                typeOriginCard === TipoCartaoEnum.HoraNaoLetivaFlutuante) ||
            typeCard === TipoCartaoEnum.HoraExtraImportacao ||
            typeCard === TipoCartaoEnum.HoraExtraTela
        );
    };

    const shouldShowActivitySelect = () => {
        return (
            typeCard === TipoCartaoEnum.HoraNaoLetiva ||
            typeCard === TipoCartaoEnum.HoraNaoLetivaFlutuante ||
            typeCard === TipoCartaoEnum.Esporadica
        );
    };

    const shouldShowCourseName = () => {
        return (
            typeCard === TipoCartaoEnum.HoraLetiva ||
            typeCard === TipoCartaoEnum.HoraNaoLetivaFlutuante ||
            (typeCard === TipoCartaoEnum.Antecipacao &&
                typeOriginCard === TipoCartaoEnum.HoraLetiva) ||
            (typeCard === TipoCartaoEnum.Antecipacao &&
                typeOriginCard === TipoCartaoEnum.HoraNaoLetivaFlutuante) ||
            typeCard === TipoCartaoEnum.HoraExtraImportacao ||
            typeCard === TipoCartaoEnum.HoraExtraTela
        );
    };

    const shouldShowLocal = () => {
        return (
            typeCard === TipoCartaoEnum.HoraLetiva ||
            typeCard === TipoCartaoEnum.HoraNaoLetivaFlutuante ||
            (typeCard === TipoCartaoEnum.Antecipacao &&
                typeOriginCard === TipoCartaoEnum.HoraLetiva)
        );
    };

    // eslint-disable-next-line sonarjs/no-identical-functions
    const shouldShowPeriod = () => {
        return (
            typeCard === TipoCartaoEnum.HoraLetiva ||
            typeCard === TipoCartaoEnum.HoraNaoLetivaFlutuante ||
            (typeCard === TipoCartaoEnum.Antecipacao &&
                typeOriginCard === TipoCartaoEnum.HoraLetiva) ||
            (typeCard === TipoCartaoEnum.Antecipacao &&
                typeOriginCard === TipoCartaoEnum.HoraNaoLetivaFlutuante)
        );
    };

    // eslint-disable-next-line sonarjs/no-identical-functions
    const shouldShowClass = () => {
        return (
            typeCard === TipoCartaoEnum.HoraLetiva ||
            typeCard === TipoCartaoEnum.HoraNaoLetivaFlutuante ||
            (typeCard === TipoCartaoEnum.Antecipacao &&
                typeOriginCard === TipoCartaoEnum.HoraLetiva) ||
            (typeCard === TipoCartaoEnum.Antecipacao &&
                typeOriginCard === TipoCartaoEnum.HoraNaoLetivaFlutuante)
        );
    };

    // eslint-disable-next-line sonarjs/no-identical-functions
    const shouldShowDivision = () => {
        return (
            typeCard === TipoCartaoEnum.HoraLetiva ||
            typeCard === TipoCartaoEnum.HoraNaoLetivaFlutuante ||
            (typeCard === TipoCartaoEnum.Antecipacao &&
                typeOriginCard === TipoCartaoEnum.HoraLetiva) ||
            (typeCard === TipoCartaoEnum.Antecipacao &&
                typeOriginCard === TipoCartaoEnum.HoraNaoLetivaFlutuante)
        );
    };

    const shouldShowHourType = () => {
        return (
            typeCard === TipoCartaoEnum.HoraLetiva ||
            typeCard === TipoCartaoEnum.HoraNaoLetiva ||
            typeCard === TipoCartaoEnum.HoraNaoLetivaFlutuante ||
            typeCard === TipoCartaoEnum.Esporadica
        );
    };

    const loadPermissionCard = () => {
        return typeCard === TipoCartaoEnum.Substituicao
            ? setPermission(
                  typeOriginCard === TipoCartaoEnum.HoraLetiva ||
                      typeOriginCard === TipoCartaoEnum.HoraNaoLetivaFlutuante
                      ? schoolHoursSubstitutionCardPermission
                      : nonSchoolHoursSubstitutionCardPermission
              )
            : setPermission({
                  nomeAtividade: shouldShowActivityName(),
                  nomeAtividadeSelect: shouldShowActivitySelect(),
                  nomeCurso: shouldShowCourseName(),
                  local: shouldShowLocal(),
                  periodo: shouldShowPeriod(),
                  turma: shouldShowClass(),
                  divisao: shouldShowDivision(),
                  tipoHora: shouldShowHourType(),
                  horaInicio: true,
                  horaFim: true,
                  statusCheckin: true,
              });
    };

    const handleClick = () => {
        const validCheckTurn = checkTurn(dateNowSchoolTime, props.params);
        const cartao = props.detail;
        if (validCheckTurn === turn || isOvertimeCard(cartao)) {
            props.handleCheckin(props.detail.cartaoAgendaId).then((r) => {
                if (r) {
                    props.setValidTurn(true);
                }
            });
        } else {
            props.setValidTurn(false);
        }
    };

    const getInfoCheckIn = () => {
        const checkinStatuses = (
            Object.keys(StatusCheckinEnum) as Array<StatusCheckinEnumType>
        ).reduce((acc, curr) => {
            if (
                curr ===
                StatusCheckinEnumLabel.get(StatusCheckinEnum.CheckinRealizado)
                    ?.replace(" ", "")
                    .replace("-", "")
            ) {
                return {
                    ...acc,
                    [StatusCheckinEnumLabel.get(
                        StatusCheckinEnum[curr]
                    ) as string]: StringUtils.formatDateString(
                        props.detail?.dataHoraCheckIn,
                        "dd/MM/yyyy - HH':'mm"
                    ),
                };
            }

            if (
                curr ===
                StatusCheckinEnumLabel.get(StatusCheckinEnum.AguardandoCheckin)
                    ?.replace(" ", "")
                    .replace("-", "")
            ) {
                return {
                    ...acc,
                    [StatusCheckinEnumLabel.get(
                        StatusCheckinEnum[curr]
                    ) as string]: StringUtils.isAfterCurrentDate(
                        props.detail?.start
                    )
                        ? "Não realizado"
                        : "-",
                };
            }

            return {
                ...acc,
                [StatusCheckinEnumLabel.get(StatusCheckinEnum[curr]) as string]:
                    StatusCheckinEnumLabel.get(StatusCheckinEnum[curr]),
            };
        }, {});

        return checkinStatuses[checkinStatus as keyof typeof checkinStatuses];
    };

    const getJustificationDate = async () => {
        const { cartaoAgendaId } = props.detail;

        try {
            const justificationDateResponse =
                await CartoesService.getJustificationDate(
                    instance,
                    cartaoAgendaId
                );

            if (GenericUtils.isSuccessStatus(justificationDateResponse)) {
                const { data } = justificationDateResponse;

                setJustificationDate(
                    data ? new Date(`${data}T23:59:59`) : null
                );
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    };

    useEffect(() => {
        const validCheckTurn = checkTurn(dateNowSchoolTime, props.params);
        if (turn !== validCheckTurn) {
            props.setValidTurn(false);
        } else if (format(new Date(), MASK_DATE) !== props.detail?.data) {
            props.setValidTurn(false);
        }
    }, [turn]);

    useEffect(() => {
        loadPermissionCard();
        getSporadicActivities();
        getJustificationDate();
    }, []);

    function statusCheckin() {
        return (
            Boolean(props.detail?.dataHoraCheckIn) ||
            checkinStatus ===
                StatusCheckinEnumLabel.get(StatusCheckinEnum.AbonoLegal) ||
            checkinStatus ===
                StatusCheckinEnumLabel.get(
                    StatusCheckinEnum.AbonoAdministrativo
                )
        );
    }

    const noCheckinJustification = (
        <>
            <Row xs="12" className="mt-3">
                <Col>
                    <StyledDetails>
                        Justificativa de check-in não realizado
                    </StyledDetails>
                </Col>
            </Row>
            <Row xs="12">
                <Col xs="12">
                    <StyledInfoLabel>Motivo</StyledInfoLabel>
                    <StyledInfoText>
                        {props.detail?.motivoJustificativa}
                    </StyledInfoText>
                </Col>
            </Row>
        </>
    );

    const checkInterjourney =
        checkinStatus ===
        StatusCheckinEnumLabel.get(StatusCheckinEnum.DesabilitadoInterjornada);

    function isDateBeforeOrEqualToday(date: Date): boolean {
        const today = new Date();
        return today <= date;
    }

    function isRangedHoliday(date: string): boolean {
        const inputDate = new Date(date);

        if (!props.holidays) return false;

        return props.holidays.some((range) => {
            if (props.detail.abrangencia.campus !== range.campus) {
                return false;
            }
            const startDate = new Date(range.start);
            const endDate = new Date(range.end);

            return inputDate >= startDate && inputDate <= endDate;
        });
    }

    // eslint-disable-next-line consistent-return
    const disableJustifyButton = () => {
        const { data, cartaoTipo } = props.detail;

        const checkIfCardHasDateTimeCheckIn = Boolean(
            props.detail?.dataHoraCheckIn
        );

        const checkIfCardHasId = props.detail.cartaoAgendaId;

        const statusCheckinInvalidos = [
            StatusCheckinEnumLabel.get(StatusCheckinEnum.Ferias),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.LicencaRemunerada),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.LicencaNaoRemunerada),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.Inativo),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.AbonoAnalise),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.AbonoAdministrativo),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.CheckinJustificado),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.CheckinRealizado),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.AbonoLegal),
        ];

        const statusCheckInNaoPermitidoJustificar = [
            StatusCheckinEnumLabel.get(StatusCheckinEnum.Compensado),
            StatusCheckinEnumLabel.get(
                StatusCheckinEnum.PendenciaJustificativa
            ),
        ];

        if (isRangedHoliday(data)) {
            return true;
        }

        if (props.isSaveScheduleButtonDisabled) {
            return true;
        }

        if (
            cartaoTipo &&
            cartaoTipo?.cartaoTipoId === TipoCartaoEnum.AtividadesAvulsas
        ) {
            return true;
        }

        if (
            cartaoTipo &&
            statusCheckInNaoPermitidoJustificar.includes(checkinStatus) &&
            !user1.isDac
        ) {
            return true;
        }

        if (
            pathLocation === Routes.MinhaAgenda &&
            [
                StatusCheckinEnumLabel.get(StatusCheckinEnum.Ausencia),
                StatusCheckinEnumLabel.get(
                    StatusCheckinEnum.AusenciaJustificada
                ),
            ].includes(checkinStatus)
        ) {
            return true;
        }

        if (statusCheckinInvalidos.includes(checkinStatus)) {
            return true;
        }

        const isAfter = moment(
            `${data} ${props.detail?.horaInicio}`,
            "YYYY-MM-DD HH:mm"
        ).isAfter(new Date());

        if (isAfter && activityManagement) {
            return true;
        }

        if (justificationDate) {
            return !isDateBeforeOrEqualToday(justificationDate);
        }

        if (isAfter && checkInterjourney) {
            return true;
        }

        if (!isAfter && checkInterjourney) {
            return false;
        }

        if (
            isAfter ||
            checkIfCardHasDateTimeCheckIn ||
            isOvertimeCard(props.detail) ||
            !checkIfCardHasId
        ) {
            return true;
        }
    };

    const disableCheckinButton = () => {
        const validCheckTurn = checkTurn(dateNowSchoolTime, props.params);
        const card = props.detail;

        if (validCheckTurn !== turn && !isOvertimeCard(card)) {
            return true;
        }

        if (props.isSaveScheduleButtonDisabled) {
            return true;
        }

        const statusCheckinInvalidos = [
            StatusCheckinEnumLabel.get(StatusCheckinEnum.CheckinRealizado),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.CheckinJustificado),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.AbonoLegal),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.AbonoAdministrativo),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.Dispensado),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.Compensado),
            StatusCheckinEnumLabel.get(
                StatusCheckinEnum.DesabilitadoInterjornada
            ),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.Ferias),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.LicencaRemunerada),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.LicencaNaoRemunerada),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.Inativo),
            StatusCheckinEnumLabel.get(
                StatusCheckinEnum.PendenciaJustificativa
            ),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.FeriadoNacional),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.FeriadoMunicipal),
        ];

        const cardDay = Number(props.detail.data.split("-")[2]);
        const today = new Date().getDate();

        if (editMode) {
            return true;
        }

        // eslint-disable-next-line sonarjs/no-collapsible-if
        if (
            isOvertimeCard(card) &&
            !statusCheckinInvalidos.includes(checkinStatus)
        ) {
            // eslint-disable-next-line no-unneeded-ternary
            return cardDay === today ? false : true;
        }

        if (
            isValidCheckinAndTurn ||
            retroactiveBlocking ||
            (props.blockActivy &&
                props.detail.cartaoTipo.cartaoTipoId !==
                    TipoCartaoEnum.HoraLetiva) ||
            (props.blockActivy &&
                props.detail.cartaoTipo.cartaoTipoId !==
                    TipoCartaoEnum.HoraExtraImportacao) ||
            !props.detail.cartaoAgendaId ||
            Boolean(props.detail?.dataHoraCheckIn) ||
            statusCheckinInvalidos.includes(checkinStatus)
        ) {
            return true;
        }

        return false;
    };

    const statusPillMessage = (): string => {
        if (
            props.linkedCard &&
            props.linkedCard?.linkedCardType === TipoCartaoEnum.Antecipacao
        )
            return `Atividade antecipada em ${DateUtils.formatStringToBrazilianFormat(
                props.linkedCard?.linkedCardAllocationDate as string
            )}`;
        if (
            props.linkedCard &&
            props.linkedCard?.linkedCardType === TipoCartaoEnum.Reposicao
        )
            return "Atividade reposta";

        return "Atividade substituída por outro docente.";
    };

    const informationStatusCard = (
        <StyledAlertStatus>
            <AlertStatus style={{ margin: "0 16px" }} />
            <StyledAlertText>{statusPillMessage()}</StyledAlertText>
        </StyledAlertStatus>
    );

    const calculateDurationClassHour = () => {
        const calculatedDurationClassHour =
            Number(props.detail?.duracaoHoraAula) / 60;

        return `${String(calculatedDurationClassHour.toFixed(2)).replace(
            ".",
            ","
        )} h/a`;
    };

    const handleCloseEdit = () => {
        setSporadicActivitySelected([
            GenericUtils.impl<SelectOption>({
                value: "0",
                label: props.detail.tituloCartao,
            }),
        ]);

        setEditMode(false);
    };

    return (
        <>
            <Dialog
                openModal={props.open && isOpen}
                onHide={() => {
                    handleClose();
                    props.onClose?.();
                }}
                size="width-700 modal-white modal-radius-8"
            >
                {(permission?.nomeAtividade ||
                    isCartaoEspecial(props.detail.cartaoTipo.cartaoTipoId)) && (
                    <Row className="mb-3">
                        <Col xs="10">
                            <StyledProfessionalPractice>
                                {props.detail?.tituloCartao}
                            </StyledProfessionalPractice>
                        </Col>
                        <Col xs="2">
                            <StyledHour>
                                {calculateDurationClassHour()}
                            </StyledHour>
                        </Col>
                    </Row>
                )}
                {permission?.nomeAtividadeSelect &&
                    !isCartaoEspecial(props.detail.cartaoTipo.cartaoTipoId) && (
                        <Row className="d-flex align-items-center">
                            <Col xs="9">
                                <AutocompleteFloatLabelClean
                                    label="Atividade"
                                    options={sporadicActivityOptions}
                                    selected={sporadicActivitySelected}
                                    disabled={!editMode}
                                    onChange={setSporadicActivitySelected}
                                />
                            </Col>
                            {props.blockActivy ||
                                (props.validView &&
                                    props.detail.cartaoTipo.cartaoTipoId !==
                                        6 && (
                                        <Col xs="2">
                                            {editMode ? (
                                                <div
                                                    style={{ display: "flex" }}
                                                >
                                                    <BtnLink
                                                        disabled={[
                                                            TipoCartaoEnum.HoraNaoLetivaFlutuante,
                                                        ].includes(typeCard)}
                                                        onClick={() =>
                                                            handleCloseEdit()
                                                        }
                                                    >
                                                        <AiOutlineClose />
                                                    </BtnLink>
                                                    <div
                                                        style={{
                                                            width: 10,
                                                            height: 10,
                                                        }}
                                                    />
                                                    <BtnLink
                                                        disabled={!isFormValid}
                                                        onClick={handleSave}
                                                    >
                                                        <DoneIcon />
                                                    </BtnLink>
                                                </div>
                                            ) : (
                                                !statusCheckin() && (
                                                    <BtnLink
                                                        disabled={
                                                            [
                                                                TipoCartaoEnum.HoraNaoLetivaFlutuante,
                                                            ].includes(
                                                                typeCard
                                                            ) ||
                                                            [
                                                                StatusCheckinEnumLabel.get(
                                                                    StatusCheckinEnum.Ferias
                                                                ),
                                                                StatusCheckinEnumLabel.get(
                                                                    StatusCheckinEnum.Inativo
                                                                ),
                                                            ].includes(
                                                                checkinStatus
                                                            )
                                                        }
                                                        onClick={() =>
                                                            setEditMode(true)
                                                        }
                                                    >
                                                        <EditIcon />
                                                    </BtnLink>
                                                )
                                            )}
                                        </Col>
                                    ))}
                            <Col xs="1">
                                <StyledHour>
                                    {calculateDurationClassHour()}
                                </StyledHour>
                            </Col>
                        </Row>
                    )}
                {permission?.nomeCurso && (
                    <Row className="mt-2">
                        <Col xs="12">
                            <StyledCourse>
                                {props.detail?.abrangencia?.nome}
                            </StyledCourse>
                        </Col>
                    </Row>
                )}
                <Row>
                    <Col xs="12">
                        <StyledCardGrey body>
                            <Row>
                                <Col>
                                    <StyledDetails>Detalhes</StyledDetails>
                                </Col>
                            </Row>
                            {(permission?.local ||
                                permission?.periodo ||
                                permission?.turma ||
                                permission?.divisao) && (
                                <Row className="mt-3">
                                    {permission?.local && (
                                        <Col xs="3">
                                            <StyledInfoLabel>
                                                Local
                                            </StyledInfoLabel>
                                            <StyledInfoText>
                                                {props.detail?.ensalamento
                                                    ?.ensalamentoDescricao ||
                                                    "-"}
                                            </StyledInfoText>
                                        </Col>
                                    )}
                                    {permission?.periodo && (
                                        <Col xs="3">
                                            <StyledInfoLabel>
                                                Período
                                            </StyledInfoLabel>
                                            <StyledInfoText>
                                                {`${props.detail?.periodoSemestral?.periodoSemestralCodigo}º`}
                                            </StyledInfoText>
                                        </Col>
                                    )}
                                    {permission?.turma && (
                                        <Col xs="3">
                                            <StyledInfoLabel>
                                                Turma
                                            </StyledInfoLabel>
                                            <StyledInfoText>
                                                {
                                                    props.detail?.turma
                                                        ?.turmaDescricao
                                                }
                                            </StyledInfoText>
                                        </Col>
                                    )}
                                    {permission?.divisao && (
                                        <Col xs="3">
                                            <StyledInfoLabel>
                                                Divisão
                                            </StyledInfoLabel>
                                            <StyledInfoText>
                                                {
                                                    props.detail?.divisao
                                                        ?.divisaoDescricao
                                                }
                                            </StyledInfoText>
                                        </Col>
                                    )}
                                </Row>
                            )}
                            {(permission?.tipoHora ||
                                permission?.horaInicio ||
                                permission?.horaFim ||
                                permission?.statusCheckin) && (
                                <Row xs="12" className="mt-3">
                                    {permission?.tipoHora && (
                                        <Col xs="3">
                                            <StyledInfoLabel>
                                                Tipo de hora
                                            </StyledInfoLabel>
                                            <StyledInfoText>
                                                {
                                                    props.detail?.tipoHora
                                                        ?.tipoHoraDescricao
                                                }
                                            </StyledInfoText>
                                        </Col>
                                    )}
                                    {permission?.horaInicio && (
                                        <Col xs="3">
                                            <StyledInfoLabel>
                                                Início
                                            </StyledInfoLabel>
                                            <StyledInfoText>
                                                {props.detail?.horaInicio ||
                                                    "-"}
                                            </StyledInfoText>
                                        </Col>
                                    )}
                                    {permission?.horaFim && (
                                        <Col xs="3">
                                            <StyledInfoLabel>
                                                Fim
                                            </StyledInfoLabel>
                                            <StyledInfoText>
                                                {props.detail?.horaFim || "-"}
                                            </StyledInfoText>
                                        </Col>
                                    )}
                                    {permission?.statusCheckin && (
                                        <Col xs="3">
                                            <StyledInfoLabel>
                                                Check-in
                                            </StyledInfoLabel>
                                            <StyledInfoText
                                                key={
                                                    props.detail
                                                        ?.dataHoraCheckIn
                                                }
                                            >
                                                {getInfoCheckIn()}
                                            </StyledInfoText>
                                            {(checkinStatus ===
                                                legalAllowance ||
                                                checkinStatus ===
                                                    adminAllowance) &&
                                            user1.isDac &&
                                            props.edicaoAgenda ? (
                                                <div>
                                                    <StyledDefaultButtonLink
                                                        disabled={
                                                            props.blockActivy
                                                        }
                                                        variant="link"
                                                        onClick={() => {
                                                            setModalDelAbono(
                                                                true
                                                            );
                                                            setIsOpen(false);
                                                        }}
                                                    >
                                                        <DeleteIcon
                                                            style={{
                                                                fill: "#8A0538",
                                                                marginLeft: -25,
                                                            }}
                                                        />
                                                        Excluir
                                                    </StyledDefaultButtonLink>
                                                </div>
                                            ) : null}
                                        </Col>
                                    )}
                                </Row>
                            )}

                            {[
                                StatusCheckinEnumLabel.get(
                                    StatusCheckinEnum.AbonoLegal
                                ),
                                StatusCheckinEnumLabel.get(
                                    StatusCheckinEnum.AbonoAdministrativo
                                ),
                                StatusCheckinEnumLabel.get(
                                    StatusCheckinEnum.DeferidoPeloCordenador
                                ),
                                StatusCheckinEnumLabel.get(
                                    StatusCheckinEnum.IndeferidoPeloCordenador
                                ),
                            ].includes(checkinStatus) && noCheckinJustification}
                        </StyledCardGrey>
                        {[
                            StatusCheckinEnumLabel.get(
                                StatusCheckinEnum.PendenciaJustificativa
                            ),
                            StatusCheckinEnumLabel.get(
                                StatusCheckinEnum.Compensado
                            ),
                        ].includes(checkinStatus) && informationStatusCard}
                        {props.blockActivy ||
                            (props.validView && (
                                <div className="mt-4 d-flex justify-content-between">
                                    <BtnLink
                                        disabled={disableJustifyButton()}
                                        onClick={() => {
                                            setIsOpen(false);
                                            setModalJustify(true);
                                        }}
                                    >
                                        {checkinStatus ===
                                        StatusCheckinEnumLabel.get(
                                            StatusCheckinEnum.CheckinJustificado
                                        )
                                            ? StatusCheckinEnumLabel.get(
                                                  StatusCheckinEnum.CheckinJustificado
                                              )
                                            : `Justificar check-in`}
                                    </BtnLink>
                                    <BtnOutlinePrimary
                                        key={props.detail?.dataHoraCheckIn}
                                        disabled={disableCheckinButton()}
                                        onClick={handleClick}
                                    >
                                        <CheckIcon className="me-2" />
                                        Realizar check-in
                                    </BtnOutlinePrimary>
                                </div>
                            ))}
                        {props.blockActivy &&
                            (props.detail.cartaoTipo.cartaoTipoId ===
                                TipoCartaoEnum.HoraLetiva ||
                                props.detail.cartaoTipo.cartaoTipoId ===
                                    TipoCartaoEnum.HoraExtraImportacao) &&
                            pathLocation === Routes.MinhaAgenda &&
                            props.validView && (
                                <div className="mt-4 d-flex justify-content-between">
                                    <BtnLink
                                        disabled={disableJustifyButton()}
                                        onClick={() => {
                                            setIsOpen(false);
                                            setModalJustify(true);
                                        }}
                                    >
                                        {checkinStatus ===
                                        StatusCheckinEnumLabel.get(
                                            StatusCheckinEnum.CheckinJustificado
                                        )
                                            ? StatusCheckinEnumLabel.get(
                                                  StatusCheckinEnum.CheckinJustificado
                                              )
                                            : `Justificar check-in`}
                                    </BtnLink>
                                    <BtnOutlinePrimary
                                        key={props.detail?.dataHoraCheckIn}
                                        disabled={disableCheckinButton()}
                                        onClick={handleClick}
                                    >
                                        <CheckIcon className="me-2" />
                                        Realizar check-in
                                    </BtnOutlinePrimary>
                                </div>
                            )}
                        {props.blockActivy &&
                            pathLocation === Routes.EditarAgenda && (
                                <div className="mt-4 d-flex justify-content-end">
                                    <BtnLink
                                        disabled={
                                            props.detail.cartaoTipo
                                                ?.cartaoTipoId ===
                                                TipoCartaoEnum.AtividadesAvulsas ||
                                            isOvertimeCard(props.detail) ||
                                            !(
                                                checkinStatus ===
                                                    StatusCheckinEnumLabel.get(
                                                        StatusCheckinEnum.AguardandoCheckin
                                                    ) ||
                                                checkinStatus ===
                                                    StatusCheckinEnumLabel.get(
                                                        StatusCheckinEnum.Dispensado
                                                    ) ||
                                                checkinStatus ===
                                                    StatusCheckinEnumLabel.get(
                                                        StatusCheckinEnum.Compensado
                                                    ) ||
                                                checkinStatus ===
                                                    StatusCheckinEnumLabel.get(
                                                        StatusCheckinEnum.Ausencia
                                                    ) ||
                                                checkinStatus ===
                                                    StatusCheckinEnumLabel.get(
                                                        StatusCheckinEnum.AusenciaJustificada
                                                    )
                                            ) ||
                                            !props.detail.cartaoAgendaId ||
                                            Boolean(
                                                props.detail?.dataHoraCheckIn
                                            ) ||
                                            checkinStatus ===
                                                StatusCheckinEnumLabel.get(
                                                    StatusCheckinEnum.AbonoLegal
                                                ) ||
                                            checkinStatus ===
                                                StatusCheckinEnumLabel.get(
                                                    StatusCheckinEnum.AbonoAdministrativo
                                                ) ||
                                            moment(
                                                `${props.detail.data} ${props.detail?.horaInicio}`,
                                                "YYYY-MM-DD HH:mm"
                                            ).isAfter(new Date()) ||
                                            isRangedHoliday(props.detail.data)
                                        }
                                        onClick={() => {
                                            setIsOpen(false);
                                            setModalJustify(true);
                                        }}
                                    >
                                        {checkinStatus ===
                                        StatusCheckinEnumLabel.get(
                                            StatusCheckinEnum.CheckinJustificado
                                        )
                                            ? StatusCheckinEnumLabel.get(
                                                  StatusCheckinEnum.CheckinJustificado
                                              )
                                            : `Justificar check-in`}
                                    </BtnLink>
                                </div>
                            )}
                    </Col>
                </Row>
            </Dialog>
            {modalJustify && modalJustifyCheckin}
            {dialogMessageProps.show && dialogMessage}
            {modalDelAbono && modalDeleteAbono}
        </>
    );
}

export default ModalViewDetails;
